import { useEffect } from "react";

export default function useSEO({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) return;
      el.setAttribute(attr, value);
    };
    if (description) {
      let meta = document.head.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
      set('meta[property="og:description"]', "content", description);
    }
    if (title) {
      set('meta[property="og:title"]', "content", title);
    }
    if (path) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (link) link.setAttribute("href", `https://sefkam.com${path}`);
      set('meta[property="og:url"]', "content", `https://sefkam.com${path}`);
    }
    window.scrollTo(0, 0);
  }, [title, description, path]);
}
